import { render, staticRenderFns } from "./ManageSpecialRegion.vue?vue&type=template&id=bd5a391a&lang=pug&"
import script from "./ManageSpecialRegion.vue?vue&type=script&lang=js&"
export * from "./ManageSpecialRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports